export default "__VITE_ASSET__CMgLxJ8l__"